import React, { useState, useEffect } from 'react';
// import Layout from '@/common/Layout';
import { Form, Card, Space, Tag } from 'antd';
import FormItem from '@/common/FormItem';
import useServerPagination from '@/hooks/useServerPagination';
import styles from '@/common/Layout/index.module.less';
import { getAllEqpLogBooksdetails } from '../../redux/slice';
import CustomTable from 'common/Content/CustomTable';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
import Layout from '@/common/Layout';
import { QrReader } from 'react-qr-reader';
import { useDispatch } from 'react-redux';
import { QrcodeOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { getLoggedInUser } from 'utilities/helpers';
import moment from 'moment';

// const { Search } = Input;

const LogbookList = ({ loading }) => {
  const [form] = Form.useForm();
  const [allLogs, setAlllogs] = useState([]);
  const { page, pageSize, onChange, reset } = useServerPagination();
  const [pagination, setPagination] = useState({});
  const [search, setSearch] = useState('');
  const [openCam, setOpenCam] = useState(false);
  const [urlType, setUrlType] = useState('');
  const { user } = getLoggedInUser();

  console.log(allLogs);
  const dispatch = useDispatch();

  // Get type from URL query params - use location.search to make it reactive
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const type = urlParams.get('type') || '';

  useEffect(() => {
    handleGetAllLogDetails();
  }, [page, pageSize, search, type, urlType]);

  useEffect(reset, [search]);

  const handleGetAllLogDetails = () => {
    const payload = type
      ? { page: page, search: search, per_page: pageSize, type }
      : { page: page, search: search, per_page: pageSize };
    dispatch(getAllEqpLogBooksdetails(payload)).then((response) => {
      if (response?.payload?.success) {
        setAlllogs(response?.payload?.data);
        setPagination(response?.payload?.pagination);
      }
    });
  };

  // const handleChange = (e) => {
  //   setSearch(e.target.value);
  // };

  const handleError = (err) => {
    console.error(err);
  };

  const handleQrScan = async (scanData) => {
    if (scanData && scanData !== '') {
      setSearch(scanData.text);
      setOpenCam(false);
    }
  };

  const handleBackToList = () => {
    console.log('back to list');
    setUrlType('');
    history.push('/equipment-log-book-list');
  };
  console.log(urlType, type);
  const handleRatification = () => {
    // setUrlType('ratification');
    history.push('/equipment-log-book-list?type=ratification');
  };

  const handleRatificationSummary = () => {
    // setUrlType('ratification');
    history.push('/ratification_summary');
  };

  //   console.log(allSamples);
  const columns = [
    {
      title: 'Activity',
      dataIndex: 'eqp_log_type',
      key: 'eqp_log_type',
      ellipsis: true,
      width: '100px',
      render: (text) => {
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
      }
    },
    {
      title: 'Batch #',
      dataIndex: 'product_batch',
      key: 'product_batch',
      ellipsis: true,
      width: '100px',
      render: (text) => {
        return text || 'NA';
      }
    },
    {
      title: 'Product/Activity Name',
      dataIndex: 'product_name',
      key: 'product_name',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return text || record?.eqp_activity || 'NA';
      }
    },
    {
      title: 'Equipment #',
      dataIndex: 'equipment_id',
      key: 'equipment_id',
      ellipsis: true,
      width: '100px'
    },
    {
      title: 'Started By (Date & Time)',
      dataIndex: 'start_user',
      key: 'start_user',
      ellipsis: true,
      width: '185px',
      render: (text, record) => {
        const dateText =
          text +
          ' (' +
          moment(record?.start_date).local().format('DD MMM YYYY HH:mm') +
          ')';

        // Check Conditions
        const showChip = record?.is_start_date === true && record?.status;
        let chipColor = '';

        if (record?.status === 'QA Pending') {
          chipColor = 'orange';
        } else {
          chipColor = 'green';
        }

        return (
          <Space size={4}>
            <span>{text ? dateText : 'NA'}</span>
            {showChip && (
              <Tag
                color={chipColor}
                style={{ fontSize: 9, lineHeight: '14px' }}
              >
                Edited
              </Tag>
            )}
          </Space>
        );
      }
    },
    {
      title: 'Stopped By (Date & Time)',
      dataIndex: 'end_user',
      key: 'end_user',
      ellipsis: true,
      width: '185px',
      // render: (text, record) => {
      //   return text
      //     ? text +
      //         '(' +
      //         moment(record?.end_date).local().format('DD MMM YYYY HH:mm') +
      //         ')'
      //     : 'NA';
      // }
      render: (text, record) => {
        const dateText =
          text +
          ' (' +
          moment(record?.end_date).local().format('DD MMM YYYY HH:mm') +
          ')';

        // Check Conditions
        const showChip = record?.is_end_date === true && record?.status;
        let chipColor = '';

        if (record?.status === 'QA Pending') {
          chipColor = 'orange';
        } else {
          chipColor = 'green';
        }

        return (
          <Space size={4}>
            <span>{text ? dateText : 'NA'}</span>
            {showChip && (
              <Tag
                color={chipColor}
                style={{ fontSize: 9, lineHeight: '14px' }}
              >
                Edited
              </Tag>
            )}
          </Space>
        );
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      width: '100px',
      render: (text) => {
        return (
          <Tag
            color={
              text === 'started'
                ? '#108ee9'
                : text === 'QA Pending'
                ? 'orange'
                : text === 'Rejected'
                ? '#e91010'
                : '#87d068'
            }
            size="small"
          >
            {text ? text.toUpperCase() : 'NA'}
          </Tag>
        );
      }
    },
    {
      title: 'Actions',
      dataIndex: 'alloted_by',
      key: 'alloted_by',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        // Add type parameter to view link if type is ratification
        const viewUrl =
          type === 'ratification' || urlType === 'ratification'
            ? `/equipment-log-book?id=${record?.id}&type=ratification`
            : type === 'initiation' || urlType === 'initiation'
            ? `/equipment-log-book?id=${record?.id}&type=initiation`
            : `/equipment-log-book?id=${record?.id}`;
        return <a href={viewUrl}>View</a>;
      }
    }
  ];

  return (
    <>
      <Layout sider={false}>
        <Form form={form} layout="vertical">
          <Card
            title={<span>Log Book Details</span>}
            className={`${styles.cardStyles_approver}`}
            extra={
              user?.role !== 'qc_initiator' && (
                <Space>
                  {urlType === 'ratification' || type === 'ratification' ? (
                    <>
                      <CustomButton
                        className={styles.inwardButton}
                        onClick={handleBackToList}
                        type="primary"
                      >
                        Back to List
                      </CustomButton>
                      <CustomButton
                        className={styles.qrcode}
                        onClick={() => setOpenCam(true)}
                      >
                        <QrcodeOutlined /> Scan by Equipment
                      </CustomButton>
                    </>
                  ) : (
                    <>
                      <CustomButton
                        className={styles.inwardButton}
                        onClick={handleRatification}
                        type="primary"
                      >
                        Ratification
                      </CustomButton>
                      <CustomButton
                        className={styles.inwardButton}
                        onClick={handleRatificationSummary}
                        type="primary"
                      >
                        Ratification Summary
                      </CustomButton>
                      <CustomButton
                        className={styles.qrcode}
                        onClick={() => setOpenCam(true)}
                      >
                        <QrcodeOutlined /> Scan by Equipment
                      </CustomButton>
                      {/* <Search
                      onChange={(e) => handleChange(e)}
                      className={`w-100 ${styles.searchbar}`}
                      justify="start"
                      align="start"
                      placeholder="Search by equipment"
                    /> */}
                      <CustomButton
                        className={styles.inwardButton}
                        onClick={() => history.push('/equipment-log-book')}
                        type="primary"
                      >
                        Create
                      </CustomButton>
                    </>
                  )}
                </Space>
              )
            }
          >
            <div className={`${styles.table_container}`}>
              <CustomTable
                columns={columns}
                showPaginationMeta
                pagination={{
                  size: 'small',
                  total: pagination?.total_records || 0,
                  current: page,
                  pageSize,
                  onChange
                }}
                dataSource={allLogs}
                loading={loading}
              />
            </div>
          </Card>
          <br />
          <FormItem className="text-center">
            <CustomButton
              className={styles.inwardButton}
              onClick={() => history.back()}
              type="primary"
            >
              Back to Home
            </CustomButton>
          </FormItem>
        </Form>
        {openCam ? (
          <QrReader
            constraints={{
              facingMode: 'environment', // Use rear camera
              width: { ideal: 1280 },
              height: { ideal: 720 }
            }}
            delay={1000}
            onError={handleError}
            onResult={handleQrScan}
            style={{
              width: '3px',
              height: '3px'
            }}
          />
        ) : (
          ''
        )}
      </Layout>
    </>
  );
};
export default LogbookList;
